import Head from 'next/head';
import Image from 'next/image';

import { createPage } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { Box, Block, Title, Flex, RouterLink, DocumentTitle } = shared;

import styles from './index.module.scss';
import DefaultLayout from '@/layouts/DefaultLayout';
import Meta from '@lib/components/head/Meta';

export default createPage('FeatureYourGamePage', { styles }, function FeatureYourGamePage ({ className }) {
	const title = 'Feature your game on iogames.space';
	const description = 'Want to get maximum exposure for your IO game? Mark your game in our dedicated feature section on the home page. Here your game will have a bigger tile to draw attention to your game and drive more traffic to it.';
  return (
    <>
      <DocumentTitle title={title} />
		<Meta
				title={title}
				description={description}
				openGraph={{
				title: title,
				description: description,
				type: 'website'
				}}
			/>
      <DefaultLayout className={className}>
        <Box>
          <Block>
            <Title size3>Want to get maximum exposure for your IO game?</Title>
            <p>
            Mark your game in our dedicated feature section on the home page. Here your game will have a bigger tile to draw attention to your game and drive more traffic to it.
            </p>
          </Block>

          <Block>
            <Flex justifySpaceEvenly container>
              <Image
                src="/images/feature/featured.png"
                alt="Featured game tile"
                width="706px"
                height="409px"
              />
            </Flex>
          </Block>

          <Block>
            <Title size3>How's it work?</Title>
            <p>
              To feature your game all you have to do is buy tokens. Each token amounts to one day that your game will be featured.
            </p>
          </Block>

          <Block>
            <Title size3>How to purchase tokens</Title>
            <p>
              To purchase tokens start by going to your <RouterLink href="/developer">developer dashboard</RouterLink>. There you can click <RouterLink href='/developer/purchase-tokens'>Purchase Tokens</RouterLink> to purchase them, and <RouterLink href='/developer/spend-tokens'>Spend Tokens</RouterLink> to use them.
            </p>
          </Block>

          <Block>
            <Title size3>New IO Games Rules For Success</Title>
            <p>
              Most fun and successful new io games like <RouterLink href="https://iogames.space/zombs-io">zombs.io</RouterLink>, <RouterLink href="https://iogames.space/zombsroyale-io">zombsroyale.io</RouterLink>, <RouterLink href="https://iogames.space/zombsroyale-io">slither.io</RouterLink>, <RouterLink href="https://iogames.space/splix-io">splix.io</RouterLink>, and <RouterLink href="https://iogames.space/moomoo-io">moomoo.io</RouterLink> follow these general guidelines:
            </p>
            <ul>
              <li>Have the player be able to hop right into a game with one click.</li>
              <li>Keep it super simple to learn but difficult to master, like with the <RouterLink href="http://iogames.space/krunker-io">krunker io game.</RouterLink></li>
              <li>Allow the player to “scale” their authority in-game compared to other players. (Ex. in agar.io you grow a lot bigger and scarier the more you eat and scale your size.)</li>
              <li>And last but not least, they are either competitive or cooperative.</li>
              <li>Slitherio is a good example. It's a very simple game, with easy-to-use controls. There's no experience required to begin playing, meaning people can get the hang of it very quickly. Despite this, the game is difficult to master. The simple, clean graphics are also worth mentioning as a relevant characteristic of the genre.</li>
            </ul>
          </Block>

          <Block>
            <Title size3>Have more questions?</Title>
            <RouterLink href="mailto:contact@iogames.space">You can contact us any time</RouterLink>
          </Block>
        </Box>
      </DefaultLayout>
    </>
  )
});
